// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__YpY92","content":"styles_content__dTtng","title":"styles_title__rHydm","description":"styles_description__m4pyM","tagList":"styles_tagList__Q7NqS"};